import { useEffect } from "react";
import Hero from "../components/sections/Hero";
import FeaturedProducts from "../components/sections/FeaturedProducts";
import Categories from "../components/sections/Categories";
import Features from "../components/sections/Features";
import Testimonials from "../components/sections/Testimonials";
import HairCareTips from "../components/sections/HairCareTips";

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Hero />
      <FeaturedProducts />
      <Categories />
      <Features />
      <HairCareTips />
      <Testimonials />
    </div>
  );
}
